import { ContractViewModel } from '@ail/contracts-api'
import React, { useEffect, useState } from 'react'
import { IElementProps, IExternalDataItem } from '../../../types/interfaces'
import ContractsSearchComponent from '../../common/Header/contractSearch/ContractSearch'
const SearchInput = (props: IElementProps) => {
  const [savedExternalData, setSavedExternalData] = useState<IExternalDataItem | undefined>(undefined)
  const { externalData, formReadOnly } = props

  useEffect(() => {
    if (
      props.visible &&
      !formReadOnly &&
      (externalData?.timeStamp || 0) > (savedExternalData?.timeStamp || 0) &&
      externalData?.data &&
      Object.keys(externalData.data).length > 0
    ) {
      const externalValue = externalData.data[Object.keys(externalData.data)[0]]

      const e = {
        target: {
          value: externalValue,
        },
      } as React.ChangeEvent<HTMLInputElement>

      setTimeout(() => {
        props.handleChange(props.name, e)
      }, props.index * 10)

      setSavedExternalData(externalData)
    }
  }, [props.externalData, formReadOnly, props.visible])

  const handleChangeInt = (model: ContractViewModel) => {
    const e = {
      target: {
        value: model.vehicle?.licencePlate?.licenseNumber,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    props.changeTrigger?.(model)
  }

  const handleLicenseDelete = (nothing: string) => {
    props.handleChange(props.name)
    props.searchStringDeleted?.(nothing)
  }

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <ContractsSearchComponent
            formReadOnly={props.formReadOnly || props.disabledInput}
            value={props.value}
            changeTrigger={(e) => handleChangeInt(e)}
            searchDeleted={(e) => handleLicenseDelete(e)}
            activeOnly={props.activeOnly}
          />
        </div>
      )}
    </>
  )
}
export default SearchInput
